import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';
import { city } from 'src/services/api-services/api-interfaces/city.interface';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { APIServiceDealer } from 'src/services/api-services/api-service-dealer';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { Workshop } from '../../../../../models/workshop';
import { WorkshopsComponent } from '../../workshops.component';
import {  createWorkshop } from 'src/models/createWorkshopInterface';
import { HelperService } from '../../../../../services/helperService';
import { chiefWorkshop } from 'src/services/api-services/api-interfaces/chiefWorkshop';
import { createWorkshopBrand } from 'src/models/createWorkshopbrandsInterface';
import { TranslateService } from '@ngx-translate/core';

interface requiredInfo {
  workshop: Workshop,
    workshopRequiredInfo:[
     Workshop[],
    brands[],
     chiefWorkshop[],
     city[],
     typeOfService[]]
}

@Component({
    selector: 'app-edit-info',
    templateUrl: './edit-info.dialog.html',
    styleUrls: ['./edit-info.dialog.sass'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})

export class EditInfoDialog implements OnInit {

  chiefOfWorkshopId:number = this.workshopRequiredList.workshop?this.workshopRequiredList.workshop.chiefOfWorkshopId :  0
  cityId:number =  this.workshopRequiredList.workshop?this.workshopRequiredList.workshop.cityId :  0;
  workshopName:string = this.workshopRequiredList.workshop?this.workshopRequiredList.workshop.workshopName :  '';
  adress: string=this.workshopRequiredList.workshop?this.workshopRequiredList.workshop.address :  ''
  phone:string =this.workshopRequiredList.workshop?this.workshopRequiredList.workshop.phoneNumber :  ''
  brandsSelected: number[]= this.workshopRequiredList.workshop? this.workshopRequiredList.workshop.brands.filter((brand)=>brand.isActive).map((brand)=>brand.brandId) :  []
  selectedServices:typeOfService[]= this.workshopRequiredList.workshopRequiredInfo[4]
  IsActiveWorkshop: boolean = this.workshopRequiredList.workshop? this.workshopRequiredList.workshop.isActive: true
  errorMessage: string = '';
  addressHasInvalidCharacters: boolean = false

  constructor(
    public HelperService: HelperService,
    public dialogRef: MatDialogRef<WorkshopsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public workshopRequiredList: requiredInfo,
    public WorkshopService: APIWorkshopService,
    public brandsService: APIBrandsService,
    public cityServiceApi: APIcityService,
    public ServiceDealer: APIServiceDealer,
    public helperService: HelperService,
    private translate: TranslateService,
  ){
  }



  ngOnInit(): void {
    if(this.workshopRequiredList.workshop){
      this.selectedServices.forEach((service)=>{
      let serviceSelect = this.workshopRequiredList.workshop.services.filter((Service)=> Service.serviceId === service.serviceId && Service.isActive === true)
      if(serviceSelect.length >0){
        service.isActive = true
      }
      else {
        service.isActive = false
      }
      })
    }
    else{
      this.selectedServices.forEach((service)=>{
        service.isActive= false
        })
    }
  }

  onSave() {
    const saveCountryBrandRetailWorkshop:createWorkshopBrand [] =[]
    this.brandsSelected.forEach((brand)=>{
      const newBrandForWorkshop = {
        countryId: this.helperService.user.countryId,
        brandId: brand,
        retailId: this.helperService.user.retailId,
        isActive: true
      }
      saveCountryBrandRetailWorkshop.push(newBrandForWorkshop)
    })

    const createWorkshop: createWorkshop =
    {
      saveWorkshopDTO: {
       workshopName: this.workshopName,
       cityId: this.cityId,
       state: this.IsActiveWorkshop,
       address: this.adress,
       phoneNumber: this.phone,
       retailId: this.helperService.user.retailId,
       chiefofWorkshopId: this.chiefOfWorkshopId,
       workshopId: this.workshopRequiredList.workshop? this.workshopRequiredList.workshop.workshopId:  0
      },
      saveCountryBrandRetailWorkshop,
      saveServicesByWorkshop:this.selectedServices

    }

    this.WorkshopService.post(createWorkshop).subscribe({
      next: (response) =>{
            if ( response.message === 'Workshop Updated Successfully.'
           || response.message === 'Workshop Created Successfully.') {
            const translateText = this.translate.instant(
              response.message === 'Workshop Updated Successfully.' ? 'ToastWorkshopEdit' : 'ToastWorkshopAdd',
              {
                fullName: this.workshopName
              }
            );
              this.helperService.showAlert =true
              this.helperService.typeAlert ="success"
              this.helperService.messageAlert =translateText
              setTimeout(() => {
                this.helperService.showAlert =false

                }, 7000)
        }


        else{
          const translateText = this.translate.instant(
            'ToastWorkshopFailed',
            {
              fullName: this.workshopName
            }
          );

          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateText

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)

        }
      },
      complete: () =>{
        this.dialogRef.close();
      },
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })






  }

  isClearDisabled(): boolean {
    // function to enable clear button conditionally
    let isDisabled = true;

    if (
      this.workshopName !== '' &&
      this.brandsSelected.length > 0 &&
      this.adress !== '' &&
      this.addressHasInvalidCharacters == false &&
      this.phone !== '' &&
      this.chiefOfWorkshopId >0  &&
      this.cityId > 0

    ) {
      isDisabled = false;
    }
    return isDisabled;
  }

  validateAddressInput(value: string): void {
    const invalidCharacters = /[^a-zA-Z0-9 ñ\-]/;
    this.addressHasInvalidCharacters = invalidCharacters.test(value);


    if (this.addressHasInvalidCharacters) {
      this.errorMessage = 'InvalidCaracter';
    } else {
      this.errorMessage = '';
    }

    this.adress = value.replace(invalidCharacters, '');
  }
}
